import { Spinner, Stack, Text, VStack } from '@chakra-ui/react';
import { IoDocuments } from 'react-icons/io5';
import CardHeaderMobile from '../../../../components/Mobile/header';
import Header from '../../../../components/Header/Header';

interface IOwnProps {
  children: React.ReactNode;
}

const ProjectDeliveryMobilePage: React.FC<IOwnProps> = ({ children }) => {
  const loading = false;
  return (
    <Stack height="100%" w="100%" top={0} bg="white" gap={0}>
      <Header />
      <VStack mt={0} flex={1} overflowY="auto" py={2}>
        {(loading && (
          <VStack flex={1} w="100%" justify="center">
            <Spinner emptyColor="gray.100" color="blue.500" size="xl" />
            <Text fontSize="sm">Buscando dados da entrega de projeto...</Text>
          </VStack>
        )) || (
          <VStack boxSizing="border-box" w={'full'} spacing={4} px={5} align="stretch">
            <CardHeaderMobile
              title="Entrega de projeto"
              subTitle=""
              badgeText="Projeto"
              badgeIcon={<IoDocuments size={12} />}
              colorScheme="blue"
            />
            {children}
          </VStack>
        )}
      </VStack>
    </Stack>
  );
};

export default ProjectDeliveryMobilePage;
